/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import React from "react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Flex, Icon, Text } from "@aws-amplify/ui-react";
export default function SideBar(props) {
  const { overrides, ...rest } = props;
  return (
    <Flex
      gap="10px"
      direction="row"
      width="385px"
      height="247px"
      alignItems="flex-start"
      position="relative"
      borderRadius="5px"
      padding="32px 0px 32px 0px"
      backgroundColor="rgba(255,255,255,1)"
      {...rest}
      {...getOverrideProps(overrides, "SideBar")}
    >
      <Flex
        gap="32px"
        direction="column"
        height="183px"
        grow="1"
        basis="385px"
        alignSelf="stretch"
        position="relative"
        padding="0px 0px 0px 0px"
        {...getOverrideProps(overrides, "Frame 32131493407")}
      >
        <Flex
          gap="32px"
          direction="column"
          height="183px"
          shrink="0"
          alignSelf="stretch"
          objectFit="cover"
          position="relative"
          padding="0px 32px 0px 32px"
          {...getOverrideProps(overrides, "Frame 32131493408")}
        >
          <Flex
            gap="16px"
            direction="column"
            shrink="0"
            position="relative"
            padding="0px 0px 0px 0px"
            {...getOverrideProps(overrides, "Frame 32131493409")}
          >
            <Text
              fontFamily="Inter"
              fontSize="16px"
              fontWeight="700"
              color="rgba(13,26,38,1)"
              lineHeight="20px"
              textAlign="left"
              display="flex"
              direction="column"
              justifyContent="flex-start"
              letterSpacing="0.49px"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              whiteSpace="pre-wrap"
              children="MY ACCOUNT"
              {...getOverrideProps(overrides, "MY ACCOUNT")}
            ></Text>
            <Flex
              gap="16px"
              direction="column"
              shrink="0"
              position="relative"
              padding="0px 0px 0px 0px"
              {...getOverrideProps(overrides, "Frame 413")}
            >
              <Flex
                gap="16px"
                direction="row"
                width="fit-content"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "OverviewFrame")}
              >
                <Icon
                  width="24px"
                  height="24px"
                  shrink="0"
                  overflow="hidden"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  viewBox={{ minX: 0, minY: 0, width: 24, height: 24 }}
                  paths={[
                    {
                      d: "M10 2.69L15 7.19L15 15L13 15L13 9L7 9L7 15L5 15L5 7.19L10 2.69ZM10 0L0 9L3 9L3 17L9 17L9 11L11 11L11 17L17 17L17 9L20 9L10 0Z",
                      fill: "rgba(13,26,38,1)",
                      fillRule: "nonzero",
                      style: { transform: "translate(8.33%, 12.5%)" },
                    },
                  ]}
                  type="home"
                  fontSize="24px"
                  {...getOverrideProps(overrides, "Icon31493413")}
                ></Icon>
                <Text
                  fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="flex"
                  direction="column"
                  justifyContent="flex-start"
                  letterSpacing="0.01px"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Overview"
                  {...getOverrideProps(overrides, "Overview")}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="row"
                width="fit-content"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "SubscriptionsFrame")}
              >
                <Icon
                  width="24px"
                  height="24px"
                  shrink="0"
                  overflow="hidden"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  viewBox={{ minX: 0, minY: 0, width: 24, height: 24 }}
                  paths={[
                    {
                      d: "M0 4L4 4L4 0L0 0L0 4ZM6 16L10 16L10 12L6 12L6 16ZM0 16L4 16L4 12L0 12L0 16ZM0 10L4 10L4 6L0 6L0 10ZM6 10L10 10L10 6L6 6L6 10ZM12 0L12 4L16 4L16 0L12 0ZM6 4L10 4L10 0L6 0L6 4ZM12 10L16 10L16 6L12 6L12 10ZM12 16L16 16L16 12L12 12L12 16Z",
                      fill: "rgba(13,26,38,1)",
                      fillRule: "nonzero",
                      style: { transform: "translate(16.67%, 16.67%)" },
                    },
                  ]}
                  type="apps"
                  fontSize="24px"
                  {...getOverrideProps(overrides, "Icon31493416")}
                ></Icon>
                <Text
                  fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="flex"
                  direction="column"
                  justifyContent="flex-start"
                  letterSpacing="0.01px"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Subscriptions"
                  {...getOverrideProps(overrides, "Subscriptions")}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="row"
                width="fit-content"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "PaymentMethodsFrame")}
              >
                <Icon
                  width="24px"
                  height="24px"
                  shrink="0"
                  overflow="hidden"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  viewBox={{ minX: 0, minY: 0, width: 24, height: 24 }}
                  paths={[
                    {
                      d: "M18 0L2 0C0.89 0 0.00999999 0.89 0.00999999 2L0 14C0 15.11 0.89 16 2 16L18 16C19.11 16 20 15.11 20 14L20 2C20 0.89 19.11 0 18 0ZM18 14L2 14L2 8L18 8L18 14ZM18 4L2 4L2 2L18 2L18 4Z",
                      fill: "rgba(13,26,38,1)",
                      fillRule: "nonzero",
                      style: { transform: "translate(8.33%, 16.67%)" },
                    },
                  ]}
                  type="credit_card"
                  fontSize="24px"
                  {...getOverrideProps(overrides, "Icon31493419")}
                ></Icon>
                <Text
                  fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="flex"
                  direction="column"
                  justifyContent="flex-start"
                  letterSpacing="0.01px"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Payment Methods"
                  {...getOverrideProps(overrides, "Payment Methods")}
                ></Text>
              </Flex>
              <Flex
                gap="16px"
                direction="row"
                width="fit-content"
                alignItems="center"
                shrink="0"
                position="relative"
                padding="0px 0px 0px 0px"
                {...getOverrideProps(overrides, "BillingHistoryFrame")}
              >
                <Icon
                  width="24px"
                  height="24px"
                  shrink="0"
                  overflow="hidden"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  viewBox={{ minX: 0, minY: 0, width: 24, height: 24 }}
                  paths={[
                    {
                      d: "M7.47 21.48C4.2 19.94 1.86 16.76 1.5 13L0 13C0.51 19.16 5.66 24 11.95 24L12.61 23.97L8.8 20.16L7.47 21.48ZM8.36 14.96C8.17 14.96 7.99 14.93 7.84 14.88C7.68 14.82 7.55 14.75 7.44 14.64C7.33 14.54 7.24 14.42 7.18 14.27C7.12 14.13 7.09 13.97 7.09 13.8L5.79 13.8C5.79 14.16 5.86 14.48 6 14.75C6.14 15.02 6.33 15.25 6.56 15.44C6.8 15.62 7.07 15.76 7.38 15.85C7.68 15.95 8 16 8.34 16C8.71 16 9.06 15.95 9.37 15.85C9.69 15.75 9.97 15.6 10.2 15.41C10.43 15.22 10.62 14.98 10.75 14.69C10.88 14.4 10.95 14.08 10.95 13.72C10.95 13.53 10.93 13.34 10.88 13.16C10.83 12.98 10.76 12.81 10.65 12.65C10.55 12.49 10.41 12.35 10.25 12.22C10.08 12.09 9.88 11.99 9.64 11.91C9.84 11.82 10.01 11.71 10.16 11.58C10.31 11.45 10.43 11.31 10.53 11.16C10.63 11.01 10.7 10.86 10.75 10.7C10.8 10.54 10.82 10.38 10.82 10.22C10.82 9.86 10.76 9.54 10.64 9.26C10.52 8.98 10.35 8.75 10.13 8.57C9.93 8.38 9.66 8.24 9.36 8.14C9.05 8.05 8.71 8 8.34 8C7.98 8 7.65 8.05 7.34 8.16C7.04 8.27 6.77 8.42 6.55 8.61C6.34 8.8 6.17 9.02 6.04 9.28C5.92 9.54 5.86 9.82 5.86 10.13L7.16 10.13C7.16 9.96 7.19 9.81 7.25 9.68C7.31 9.55 7.39 9.43 7.5 9.34C7.61 9.25 7.73 9.17 7.88 9.12C8.03 9.07 8.18 9.04 8.36 9.04C8.76 9.04 9.06 9.14 9.25 9.35C9.44 9.55 9.54 9.84 9.54 10.21C9.54 10.39 9.51 10.55 9.46 10.7C9.41 10.85 9.32 10.97 9.21 11.07C9.1 11.17 8.96 11.25 8.8 11.31C8.64 11.37 8.44 11.4 8.22 11.4L7.45 11.4L7.45 12.43L8.22 12.43C8.44 12.43 8.64 12.45 8.82 12.5C9 12.55 9.15 12.63 9.27 12.73C9.39 12.84 9.49 12.97 9.56 13.13C9.63 13.29 9.66 13.48 9.66 13.7C9.66 14.11 9.54 14.42 9.31 14.63C9.08 14.86 8.76 14.96 8.36 14.96ZM16.91 9.04C16.59 8.71 16.21 8.45 15.77 8.27C15.33 8.09 14.84 8 14.3 8L11.94 8L11.94 16L14.24 16C14.79 16 15.3 15.91 15.75 15.73C16.2 15.55 16.59 15.3 16.91 14.97C17.23 14.64 17.48 14.24 17.65 13.78C17.82 13.31 17.91 12.79 17.91 12.21L17.91 11.81C17.91 11.23 17.82 10.71 17.65 10.24C17.48 9.77 17.23 9.37 16.91 9.04ZM16.52 12.2C16.52 12.62 16.47 12.99 16.38 13.33C16.28 13.66 16.14 13.95 15.95 14.18C15.76 14.41 15.52 14.59 15.24 14.71C14.95 14.83 14.62 14.89 14.25 14.89L13.34 14.89L13.34 9.12L14.31 9.12C15.03 9.12 15.58 9.35 15.95 9.81C16.33 10.27 16.52 10.93 16.52 11.8L16.52 12.2ZM11.95 0L11.29 0.03L15.1 3.84L16.43 2.51C19.7 4.06 22.04 7.23 22.39 10.99L23.89 10.99C23.39 4.84 18.24 0 11.95 0Z",
                      fill: "rgba(13,26,38,1)",
                      fillRule: "nonzero",
                      style: { transform: "translate(0.25%, 0%)" },
                    },
                  ]}
                  type="article"
                  fontSize="24px"
                  {...getOverrideProps(overrides, "Icon31493422")}
                ></Icon>
                <Text
                  fontFamily="Inter"
                  fontSize="16px"
                  fontWeight="400"
                  color="rgba(13,26,38,1)"
                  lineHeight="24px"
                  textAlign="left"
                  display="flex"
                  direction="column"
                  justifyContent="flex-start"
                  letterSpacing="0.01px"
                  shrink="0"
                  position="relative"
                  padding="0px 0px 0px 0px"
                  whiteSpace="pre-wrap"
                  children="Billing History"
                  {...getOverrideProps(overrides, "Billing History")}
                ></Text>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
}
